import { Pipe, PipeTransform } from '@angular/core';
import {eventMapping} from '../shareModel';

import * as fromMyfeatures from '../my-features';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../store';
import { first } from 'rxjs/operators';


@Pipe({
  standalone: false,
  name: 'statusEvent'
})

export class StatusEventPipe implements PipeTransform {
  eventMaps: any;
  constructor(private store: Store<fromStore.State>) {
    this.store.select(fromStore.getEventsMapsState).pipe(first(i => i.Loaded && !i.Loading)).subscribe(res => {
      this.eventMaps = res.entities;
    });
  }
  transform(value: any, args?: any): any {
    if (value === '' || typeof value === 'undefined' || value === null) {
      return '';
    }
    const eventArr = value.split(',');
    return eventArr.reduce((prevVal, currVal) => {
      if (this.eventMaps) {
        return this.eventMaps.hasOwnProperty(currVal) ? prevVal + this.eventMaps[currVal].desc + ' \n ' : '';
      }
      return eventMapping.hasOwnProperty(currVal) ? prevVal + eventMapping[currVal].desc + ' \n ' : '';
    }, '');
  }

}
